/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "Item": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "totalCost": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "totalTax": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ItemizationData": {
                "fields": {
                  "items": {
                    "type": "squareup.esperanto.api.Item",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "source": {
                    "type": "squareup.esperanto.api.ItemizationData.Source",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Source": {
                    "values": {
                      "DO_NOT_USE_SOURCE": 0,
                      "BILL_DATA": 1,
                      "BUSINESS_TYPE_MAPPING": 2,
                      "BILL_DATA_WITH_ESTIMATED_TAX": 3,
                      "DEFAULT_ITEMIZATION_WITH_ESTIMATED_TAX": 4,
                      "DEFAULT_ITEMIZATION": 5
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.Item && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.ItemizationData && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.ItemizationData?.nested?.Source) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Item @ squareup/esperanto/api/itemization.proto at 10:1
 */
export const Item = $root.lookupType('squareup.esperanto.api.Item');
fixType(Item);
Builder.createAndAttachToType(Item);
/**
 * SOURCE ItemizationData @ squareup/esperanto/api/itemization.proto at 24:1
 */
export const ItemizationData = $root.lookupType('squareup.esperanto.api.ItemizationData');
fixType(ItemizationData);
Builder.createAndAttachToType(ItemizationData);
/**
 * SOURCE Source @ squareup/esperanto/api/itemization.proto at 25:3
 */
ItemizationData.Source = $root.lookupEnum('squareup.esperanto.api.ItemizationData.Source').values;